var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeedHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12C3.46235 12 1 9.53765 1 6.5C1 3.46235 3.46235 1 6.5 1C9.53765 1 12 3.46235 12 6.5C12 9.53765 9.53765 12 6.5 12ZM6.5 11.34C7.78365 11.34 9.01472 10.8301 9.9224 9.9224C10.8301 9.01472 11.34 7.78365 11.34 6.5C11.34 5.21635 10.8301 3.98528 9.9224 3.0776C9.01472 2.16993 7.78365 1.66 6.5 1.66C5.21635 1.66 3.98528 2.16993 3.0776 3.0776C2.16993 3.98528 1.66 5.21635 1.66 6.5C1.66 7.78365 2.16993 9.01472 3.0776 9.9224C3.98528 10.8301 5.21635 11.34 6.5 11.34Z",
    fill: "#FF9436",
    stroke: "#FF9436",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32852 9.57422V5.37422H7.14609V9.57422H6.32852ZM6.74141 4.72617C6.59922 4.72617 6.47708 4.67878 6.375 4.58398C6.27474 4.48737 6.22461 4.37253 6.22461 4.23945C6.22461 4.10456 6.27474 3.98971 6.375 3.89492C6.47708 3.79831 6.59922 3.75 6.74141 3.75C6.88359 3.75 7.00482 3.79831 7.10508 3.89492C7.20716 3.98971 7.2582 4.10456 7.2582 4.23945C7.2582 4.37253 7.20716 4.48737 7.10508 4.58398C7.00482 4.67878 6.88359 4.72617 6.74141 4.72617Z",
    fill: "#FF9436",
    stroke: "#FF9436",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelp);
export default __webpack_public_path__ + "static/media/need_help.662c23684e8e597d768e334694c619e6.svg";
export { ForwardRef as ReactComponent };